<template>
  <div class="index-page">
    <base-header class="header-cont"></base-header>

    <router-view></router-view>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import BaseHeader from '../components/BaseHeader.vue'
export default {
  name: 'Index',
  components: {
    BaseHeader
  },
  data() {
    return {
      menuList: [
        { id: 0, name: '首页', url: '/' },
        {
          id: 1,
          name: '业务领域',
          url: '/area',
          children: [
            {
              id: 5,
              name: '工业产品',
              url: '/area/pro'
            },
            {
              id: 6,
              name: '自控系统研发',
              url: '/area/dev'
            },
            {
              id: 7,
              name: '智能视觉',
              url: '/area/vis'
            },
            {
              id: 8,
              name: '教育信息化',
              url: '/area/edu'
            }
          ]
        },
        { id: 2, name: '关于我们', url: '/about' },
        { id: 3, name: '合作客户', url: '/customer' },
        { id: 4, name: '联系我们', url: '/contact' }
      ]
    }
  },
  created() {
    this.SET_MENU(this.menuList)
  },
  methods: {
    ...mapMutations(['SET_MENU'])
  }
}
</script>

<style lang="scss" scoped>
.header-cont {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  z-index: 16;
}
</style>
